import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

export const CustomToolTip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color:"rgba(73 , 148, 236, 0.875)",
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor:"rgba(73 , 148, 236, 0.875)",
    color: "#fff",
    maxWidth: "fit-content",
    
  },
}));
